import Events from "@wwdev/bootstrap/Events";

class PreacherDeclarationRequest {
    constructor() {
        this.$scope = $('[scope=preacher-declaration-request]');

        if (this.$scope.length < 1) {
            return;
        }
        this.init();
    }

    init() {
        // this.$scope.on('mouseover', '.image',  this.showDetails)
        this.$scope.on('change', 'input[name="amount_km"]',  this.calculate.bind(this))
        Events.on('wwdev.zipcode.getCityAndStreet.success', this.calculateDistance.bind(this))
        Events.trigger('wwdev.zipcode.getCityAndStreet.success')
    }
    async calculateDistance() {
        let url = new URL(window.location.href);
        url.searchParams.set('action', 'distance');
        url.searchParams.set('zipcode', this.$scope.find('input[name=zipcode]').val());
        url.searchParams.set('street', this.$scope.find('input[name=street]').val());
        url.searchParams.set('street_number', this.$scope.find('input[name=street_number]').val());
        url.searchParams.set('town', this.$scope.find('input[name=city]').val());

        const result = await fetch( url.toString()).then(response => {
            if (!response.ok) {
                throw new Error('Netwerkfout: ' + response.status);
            }
            return response.json(); // Zet de response om naar JSON
        })
        if (result.amount_km) {
            this.$scope.find('input[name=amount_km]').val(result.amount_km).trigger('change');
        }
    }

    calculate(event) {
        let preacherCompensation = this.$scope.find('input[name="preacher_compensation"]').val().replace(',', '.') * 1;
        let travelCompensation = $(event.target).val() * 0.24;
        let totalCompensation = preacherCompensation+travelCompensation;
        this.$scope.find('input[name="travel_compensation"]').val(
            travelCompensation.toFixed(2).toString().replace(/\./, ',')
        );
        this.$scope.find('input[name="total_compensation"]').val(
            totalCompensation.toFixed(2).toString().replace(/\./, ',')
        );
    }

}

export default new PreacherDeclarationRequest();
